import React, { useContext } from "react";
import AppContext from "../../../context/AppContext";
import styled from "styled-components";
import Popup from "reactjs-popup";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "../../styling/styles.css";
import "../../styling/formik.css";
import { useAlert } from "react-alert";
import AppSettings from "../../../AppSettings";
import SubmitAccountRequest from "../../checkout/SubmitAccountRequest";

const PopupWrapper = styled.div`
  margin: 0px;
  padding: 16px 16px 0px 16px;
`;
const PopupHeading = styled.div`
	color: black;
  position: relative;
  top: -22px;
  left: -21px;
  width: 417px;
  margin: 0px;
  padding 22px;
  background-color: #ffd564;
`;
const Heading = styled.div`
  font-size: 24px;
  margin-bottom: 8px;
`;
const BodyText = styled.div`
  font-size: 18px;
  color: #615b5b;
`;
const AlertText = styled.div`
  text-transform: none;
  font-size: 14px;
`;

const FormField = ({ name, required, caption, type, component, placeholder, errors, touched }) => (
  <>
    <label htmlFor={name}>
      {caption}
      {required && <strong>*</strong>}
    </label>
    <ErrorMessage name={name} className="error" component="div" />
    <Field
      component={component || "input"}
      type={type || "text"}
      name={name}
      spellCheck="off"
      autoCorrect="off"
      placeholder={placeholder}
      className={errors[name] && touched[name] ? "text-input error" : "text-input"}
    />
  </>
);

const popupContents = (initialValues, close, onSubmit, context) => {
  return (
    <PopupWrapper className="checkout">
      <Formik
        initialValues={initialValues}
        validationSchema={inputSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          context.updateContactInfo(values);
          SubmitAccountRequest(values, onSubmit, resetForm, context.token);
          window._chatlio.identify(values.email, {
            name: values.name,
            email: values.email,
            phone: values.phone
          });
          close();
        }}
      >
        {props => {
          const { touched, errors } = props;
          return (
            <>
              <PopupHeading>
                <Heading>Are you in the trade?</Heading>
                <BodyText>
                  It's easy to set up a trade account to receive discounted pricing on all your purchases.
                </BodyText>
              </PopupHeading>
              <Form>
                <FormField
                  name="name"
                  required
                  caption="Name"
                  placeholder="Enter your full name"
                  errors={errors}
                  touched={touched}
                />
                <FormField
                  name="email"
                  required
                  caption="Email"
                  type="email"
                  placeholder="Enter email address"
                  errors={errors}
                  touched={touched}
                />
                <FormField
                  name="phone"
                  required
                  caption="Phone"
                  placeholder="Enter phone number"
                  errors={errors}
                  touched={touched}
                />
                <button className="primaryButton" type="submit">
                  Learn More
                </button>
                <button className="secondaryButton" onClick={() => close()}>
                  No, Thanks
                </button>
              </Form>
            </>
          );
        }}
      </Formik>
    </PopupWrapper>
  );
};

// Accept US, Canada and Mexican phone numbers
const phoneRegExp = /^(\+?(011[. -]?)?\+?52[. -]?([0-9]{3}[. -]?[0-9]{3}[. -]?[0-9]{4}|[0-9]{2}[. -]?[0-9]{4}[. -]?[0-9]{4})|(\+?(1[. -]?)?(\(?[0-9]{3}\)?[. -]?[0-9]{3}[. -]?[0-9]{4})))(\s?(x|ext|ext.)\s?[0-9]{1,5})?$/;
// Require first and last name
const nameRegExp = /\w\w+\s+\w\w+/;

let validations = {
  name: Yup.string()
    .required("Full name is required")
    .matches(nameRegExp, "Please provide your first and last name"),
  phone: Yup.string()
    .required("Phone number is required")
    .matches(phoneRegExp, "Phone number is not valid"),
  email: Yup.string()
    .required("Email address is required")
    .email("Invalid email")
};
const inputSchema = Yup.object().shape(validations);

export default function NewAccountPopup({ trigger }) {
  const context = useContext(AppContext);
  const alert = useAlert();
  const initialValues = {
    name: context.contactInfo.name ? context.contactInfo.name : "",
    email: context.contactInfo.email ? context.contactInfo.email : "",
    phone: context.contactInfo.phone ? context.contactInfo.phone : ""
  };
  const onSubmit = error => {
    if (error) {
      console.log(`Research request failed for ${AppSettings.EmailRequest}`, error);
      alert.error(
        <AlertText>An unexpected error occurred. Please try again and contact us if the error persists</AlertText>
      );
    } else {
      alert.success(
        <AlertText>
          You will receive an email momentarily with details about setting up a Case Parts trade account.
        </AlertText>
      );
    }
  };

  return (
    <Popup
      trigger={trigger}
      modal
      closeOnEscape
      closeOnDocumentClick={false}
      contentStyle={{ width: "450px", backgroundColor: "#f7e8bf" }}
    >
      {close => popupContents(initialValues, close, onSubmit, context)}
    </Popup>
  );
}
